<div class="loader-main" [class.loader-hidden]="!show">
  <div fxLayoutAlign="center center" class="loader-overlay">
    <div class="loader-img">
      <div *ngIf="show" fxFlexAlign="center center" class="fa  fa-lg fa-pulse fa-spinner"></div>
    </div>
  </div>
</div>